import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de perfil.
 *
 * `/profile` já era o destino do último item da `BottomNav` (`src/config/navigation.ts`)
 * antes de existir uma página — o item levava a "Página não encontrada". O caminho
 * é ditado por lá e não deve divergir dele.
 *
 * Fica **dentro** do `AppLayout`, ao contrário das rotas de auth: é uma das cinco
 * áreas da barra inferior, e uma delas que escondesse a própria barra deixaria a
 * pessoa sem como voltar às outras quatro.
 *
 * `/profile/edit` é o oposto e por isso mora em `profileProtectedRoutes`: é
 * formulário, monta fora do `AppLayout` e exige sessão. Sem o guard, a rota
 * carregaria para convidado e mostraria um formulário que a RLS nunca deixaria
 * salvar.
 */
const ProfilePage = lazy(() => import('./routes/Profile.page'));
const EditProfilePage = lazy(() => import('./routes/EditProfile.page'));

export const profileRoutes: RouteObject[] = [{ path: 'profile', element: <ProfilePage /> }];

export const profileProtectedRoutes: RouteObject[] = [
  { path: 'profile/edit', element: <EditProfilePage /> },
];
